import { FC, useContext, useEffect, useState } from "react";
import { Col, Row } from "../../components/grid";
import { Section } from "../../components/layout/Section";
import { Text } from "../../components/typography/Text";
import { fetchContact } from "../../data/data";
import { AppContext } from "./Profile";

type ContactEntry = {
  label: string;
  text: string;
  link: string;
};

export const Contact: FC = () => {
  const [list, setList] = useState<ContactEntry[]>();
  const { markSectionLoaded } = useContext(AppContext);
  useEffect(() => {
    fetchContact().then((response) => {
      setList(
        response.map((row) => ({
          label: row[0],
          text: row[1],
          link: row[2],
        }))
      );
      markSectionLoaded("contact");
    });
  }, [markSectionLoaded]);

  const handleClickEntry = (entry: ContactEntry) => {
    window.open(entry.link);
  };

  return (
    <Section title="Contact" busy={!list}>
      <Row>
        {list?.map((entry, idx) => (
          <Col key={idx} span={24}>
            <Text opacity={50}>{entry.label}</Text>
            <br />
            <Text
              weight="bold"
              onClick={entry.link ? () => handleClickEntry(entry) : undefined}
            >
              {entry.text}
            </Text>
          </Col>
        ))}
      </Row>
      {/* <ContactButton
        emailLink={list?.find((e) => e.link.startsWith("mailto"))?.link}
      /> */}
    </Section>
  );
};
